import queryString from 'query-string';
import conf from '../config';
//import { callApi, history } from '../store';

const initialState = {
  models: {},
  materials: {},
  scenes: {},
};

const ADD_COMMENT = 'ADD_COMMENT';
const SET_COMMENTS = 'SET_COMMENTS';

export default (state = initialState, action) => {
  let comments = null;
  switch (action.type) {
    case SET_COMMENTS:
      comments = state[action.payload.type];
      comments[action.payload.id] = action.payload.comments;
      return { ...state, comments };
    case ADD_COMMENT:
      comments = state[action.payload.type];
      if (!comments[action.payload.id])
        comments[action.payload.id] = [action.payload.comment];
      else comments[action.payload.id].unshift(action.payload.comment);
      return { ...state, comments };
    default:
      return state;
  }
};

const addComment = (type, id, comment) => ({
  type: ADD_COMMENT,
  payload: { type, id, comment },
});

const setComments = (type, id, comments) => ({
  type: SET_COMMENTS,
  payload: { type, id, comments },
});

export const getComments = (state, type, id) => state.comments[type];

export function createComment(comment, type, files) {
  return async dispatch => {
    const form = new FormData();
    for (let i in comment) {
      if (typeof comment[i] === 'object') {
      } else {
        form.append(i, comment[i]);
      }
    }
    for (let i in files) {
      form.append(files[i].name, files[i]);
    }
    const result = await fetch(`${conf.apiRoot}/api/comments`, {
      method: 'POST',
      credentials: 'include',
      body: form,
    }).then(res => {
      if (res.status === 200) return res.json();
      return null;
    });
    if (result && result.status === 'ok') {
      dispatch(addComment(type, result.model.modelId, result.model));
      return result.model;
    }
  };
}

export function fetchComments(type, id, query) {
  return async dispatch => {
    const comments = await fetch(
      `${conf.apiRoot}/api/${type}/${id}/comments?${queryString.stringify(
        query
      )}`,
      {
        credentials: 'include',
      }
    ).then(res => {
      if (res.status === 200) return res.json();
      return [];
    });
    dispatch(setComments(type, id, comments));
    return comments;
  };
}



// WEBPACK FOOTER //
// ./src/modules/comments.js